import React, { Fragment } from 'react';
import { Table } from 'antd';
import { connect } from 'dva';
import { formatPrice, formatTimestamp } from 'utils/utils.js';
import styles from './Table.less';

@connect(({ schoolOrder, loading }) => ({
  loading: loading.effects['schoolOrder/fetchDataSource'],
  dataSource: schoolOrder.dataSource,
  pagination: schoolOrder.pagination,
}))
export default class Record extends React.Component {
  handleTableChange(pagination, filters, sorter) {
    this.props.dispatch({
      type: 'schoolOrder/savePagination',
      pagination: {
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });

    if (this.props.onChange) {
      this.props.onChange(pagination, filters, sorter);
    }
  }

  render() {
    const columns = [
      {
        title: '订单号',
        dataIndex: 'id',
      },
      {
        title: '年级',
        dataIndex: 'gradeName',
      },
      {
        title: '班级',
        dataIndex: 'className',
      },
      {
        title: '学生姓名',
        dataIndex: 'userName',
      },
      {
        title: '已选商品信息',
        dataIndex: 'commodityNames',
      },
      {
        title: '订单金额（元）',
        dataIndex: 'price',
        render: val => formatPrice(val),
      },
      {
        title: '支付时间',
        dataIndex: 'gmtEnd',
        render: val => formatTimestamp(val),
      },
      {
        title: '操作',
        render: rowData => (
          <Fragment>
            <a
              onClick={() => {
                this.props.dispatch({
                  type: 'schoolOrder/fetchOrderDetail',
                  id: rowData.id,
                });

                this.props.dispatch({
                  type: 'schoolOrder/toggleModalVisibility',
                  modal: {
                    show: true,
                    rowData,
                  },
                });
              }}
            >
              查看
            </a>
          </Fragment>
        ),
      },
    ];

    const pagination = {
      showQuickJumper: true,
      showSizeChanger: true,
      current: this.props.pagination.current,
      total: this.props.pagination.total,
    };

    return (
      <div className={styles.root}>
        <Table
          loading={this.props.loading}
          rowKey="id"
          dataSource={this.props.dataSource}
          columns={columns}
          pagination={pagination}
          onChange={this.handleTableChange.bind(this)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/School/Order/Table.js